import { useCallback, useEffect, useState } from 'react';

import '../Vacations/home.css';
import { WebLayout } from '../../Components/WebLayout';
import { base_url } from '../../Api/apiConfig';
import { StayCard } from './VacationsHome';

const PER_PAGE = 12;

// All stays: a plain grid with a "Load more" button (no automatic scrolling).
export const VacationsListings = () => {
    const [listings, setListings] = useState([]);
    const [page, setPage] = useState(0);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const load = useCallback(async (pageNum) => {
        setLoading(true);
        setError(false);
        try {
            const response = await fetch(`${base_url}/frontend/listings?page=${pageNum}&per_page=${PER_PAGE}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('login')}`,
                },
            });
            if (!response.ok) throw new Error('bad status');
            const result = await response.json();
            const data = result?.data?.listings;
            setListings((prev) => {
                const seen = new Set(prev.map((item) => item.id));
                return [...prev, ...(data?.data || []).filter((item) => !seen.has(item.id))];
            });
            setPage(data?.current_page || pageNum);
            setLastPage(data?.last_page || 1);
            setTotal(data?.total || 0);
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        document.title = 'All Stays | Kayifi Vacations';
        load(1);
    }, [load]);

    return (
        <WebLayout>
            <div className="vx-home">
                <section className="section" style={{ paddingTop: '2rem' }}>
                    <div className="container">
                        <div className="section-head">
                            <div>
                                <span className="eyebrow">All stays</span>
                                <h2>Find your stay</h2>
                                {total > 0 && <p>{total} {total === 1 ? 'stay' : 'stays'} available.</p>}
                            </div>
                        </div>

                        <div className="listings-grid">
                            {listings.map((item) => <StayCard key={item.id} item={item} />)}
                            {!loading && !error && !listings.length && <p className="empty-note">No stays available yet.</p>}
                            {error && <p className="empty-note">Could not load the stays. Please try again.</p>}
                        </div>

                        <div className="load-more">
                            {loading && 'Loading stays...'}
                            {!loading && !error && page < lastPage && (
                                <button type="button" className="btn btn-outline-dark" onClick={() => load(page + 1)}>Load more</button>
                            )}
                            {!loading && error && (
                                <button type="button" className="btn btn-outline-dark" onClick={() => load(page + 1)}>Try again</button>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </WebLayout>
    );
};
